export default (customerFilter?: number): string =>
  `/api/streaming/sources/types${
    customerFilter ? `/real?customerFilter=${customerFilter}` : ''
  }`;
